#version 300 es
    
precision highp float;
precision highp sampler3D;

in vec3 pass_textureCoordinates;

out vec4 color;

uniform vec2 windowLevel; //ww, wc
uniform vec3 colorMask;
uniform float alpha;

uniform sampler3D sampler;

vec4 colorModification(float value){
    value = (value - windowLevel.y + (windowLevel.x * 0.5)) / windowLevel.x;
    value *= alpha;
    /*if(value < 0.0){
        discard;
    }*/
    vec3 color = colorMask * value;
    return vec4(color, 1.0);
}

void main() {
    color = colorModification(texture(sampler, pass_textureCoordinates).r);
    //color = vec4(pass_textureCoordinates, 1.0);
}